import { createRouter, createWebHistory } from 'vue-router';
import MainScene from '../components/MainScene.vue';
import GameSelection from '../components/GameSelection.vue';
import PickTheOddGame from '../components/PickTheOddGame.vue';
import SitupsGame from '../components/SitupsGame.vue';
import RunningGame from '../components/RunningGame.vue';
import PushupsGame from '../components/PushupsGame.vue';
import JumpingJacksGame from '../components/JumpingJacksGame.vue';
import JumpsGame from '../components/JumpsGame.vue';
import HighKneesGame from '../components/HighKneesGame.vue';
import HandsGame from '../components/HandsGame.vue';
import FramesGame from '../components/FramesGame.vue';
import BodyMoveGame from '../components/BodyMoveGame.vue';
import JumpRopeGame from '../components/JumpRopeGame.vue';
import JumpsPrecisionGame from '../components/JumpsPrecisionGame.vue';
import SelectMealGame from '../components/SelectMealGame.vue';
import FoodPyramidGame from '../components/FoodPyramidGame.vue';
import FoodMatchingGame from '../components/FoodMatchingGame.vue';
import StretchingGame from '../components/StretchingGame.vue';
// import TouchTheFood from '../components/TouchTheFood.vue';
import BuildWeekGame from '../components/BuildWeekGame.vue';
import PlankGame from '../components/PlankGame.vue';

import PersonalScoreboard from '../components/PersonalScoreboard.vue';
import UserAuth from '@/components/UserAuth.vue';
import UserProfile from '@/components/UserProfile.vue';
import AboutVitalia from '../components/AboutVitalia.vue';

const routes = [
  {
    path: '/',
    name: 'MainScene',
    component: MainScene, // The main world scene
  },
  {
    path: "/auth",
    name: "UserAuth",
    component: UserAuth, // Login/Register Page
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: UserProfile,
  },
  {
    path: '/about',
    name: 'AboutVitalia',
    component: AboutVitalia,
    props: false,
  },
  {
    path: '/game-selection/:time/:background/:games',
    name: 'GameSelection',
    component: GameSelection,
    props: (route) => ({
      time: route.params.time,
      background: route.params.background,
      games: route.params.games,
    }),
  },
  {
    path: '/pick-the-odd/:time/:background/:games',
    name: 'PickTheOddGame',
    component: PickTheOddGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/jump-precision/:time/:background/:games',
    name: 'JumpsPrecisionGame',
    component: JumpsPrecisionGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/running/:time/:background/:games',
    name: 'RunningGame',
    component: RunningGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/frames/:time/:background/:games',
    name: 'FramesGame',
    component: FramesGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/jumping-jacks/:time/:background/:games',
    name: 'JumpingJacksGame',
    component: JumpingJacksGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/stretching/:time/:background/:games',
    name: 'StretchingGame',
    component: StretchingGame,
    props: true, // Allows params to be passed as props
  },

  {
    path: '/jumps/:time/:background/:games',
    name: 'JumpsGame',
    component: JumpsGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/high-knees/:time/:background/:games',
    name: 'HighKneesGame',
    component: HighKneesGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/hands/:time/:background/:games',
    name: 'HandsGame',
    component: HandsGame,
    props: true, // Allows params to be passed as props
  },
  // { path: '/frames', name: 'FramesGame', component: FramesGame },
  // { path: '/body-move', name: 'BodyMoveGame', component: BodyMoveGame },
  {
    path: '/jump-rope/:time/:background/:games',
    name: 'JumpRopeGame',
    component: JumpRopeGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/select/:time/:background/:games',
    name: 'SelectMealGame',
    component: SelectMealGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/food-pyramid/:time/:background/:games',
    name: 'FoodPyramidGame',
    component: FoodPyramidGame,
    props: true, // Allows params to be passed as props
  },
  {
    path: '/food-matching/:time/:background/:games',
    name: 'FoodMatchingGame',
    component: FoodMatchingGame,
    props: true, // Allows params to be passed as props
  },
  { path: '/build-week',
    name: 'BuildWeekGame',
    component: BuildWeekGame,
    props: false, // Allows params to be passed as props
   },
   { path: '/personalscores',
    name: 'PersonalScoreboard',
    component: PersonalScoreboard,
    props: false, // Allows params to be passed as props
   },
   { path: '/pushups/:time/:background/:games',
    name: 'PushupsGame',
    component: PushupsGame,
    props: true, // Allows params to be passed as props
   },
   { path: '/situps/:time/:background/:games',
    name: 'SitupsGame',
    component: SitupsGame,
    props: true, // Allows params to be passed as props
   },
   { path: '/body-move/:time/:background/:games',
    name: 'BodyMoveGame',
    component: BodyMoveGame,
    props: true, // Allows params to be passed as props
   },
   { path: '/jumps-precision/:time/:background/:games',
    name: 'JumpsPrecisionGame',
    component: JumpsPrecisionGame,
    props: true, // Allows params to be passed as props
   },
   { path: '/plank/:time/:background/:games',
    name: 'PlankGame',
    component: PlankGame,
    props: true, // Allows params to be passed as props
   },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


// Navigation Guard: Protect Routes from Unauthorized Access
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("token") !== null;

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: "UserAuth" }); // Redirect to Login if not authenticated
  } else {
    next();
  }
});

export default router;
